// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyB3TfFglhi0sAl2DdGd5VgQ8rUwJ_x8Kec',
  authDomain: 'lens-king-108c1.firebaseapp.com',
  projectId: 'lens-king-108c1',
  storageBucket: 'lens-king-108c1.appspot.com',
  messagingSenderId: '651510828699',
  appId: '1:651510828699:web:819e4687ef7125768cc03e',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app;